import { SmartTimerProvider } from "@/v2/hooks/useSmartTimer";
import AutoCombineView from "./Entries/AutoCombineView";

export default function EntriesView() {
	return (
		<SmartTimerProvider>
			<AutoCombineView />
		</SmartTimerProvider>
	);
}
